module.exports = __webpack_public_path__ + "static/media/meteor-dribbble-3.3c2b21f5.jpg";